import React, { useState } from 'react'
import { Grid } from '@mui/material'
import {
  FormDataConsumer,
  TextInput,
  useNotify,
  useRecordContext,
  useRefresh,
} from 'react-admin'
import { validateAutoSaveSingleInput } from '../../../../Utils/AutoSave'
import { getManualCap } from '../../../../Utils/RestUtils'
import { blockInvalidCharFromNumberInput } from '../../../../Utils/ConversionUtils'

const RetailAndManualInputs = () => {
  const record = useRecordContext()
  const notify = useNotify()
  const refresh = useRefresh()
  const [isLoadingManualCap, setIsLoadingManualCap] = useState(false)
  const capHistory = record.leadContact.vehicle.vehicleCapHistory ?? []
  const vehicleCap = capHistory[capHistory.length - 1] ?? null

  const handleRetailChange = async (e) => {
    if (!isLoadingManualCap) {
      setIsLoadingManualCap(true)
      //update DB value
      await validateAutoSaveSingleInput(record, e.target, null, null)

      //calculate manual CAP
      await getManualCap(record.leadContact.vehicle['@id'], true)

      refresh()
      setIsLoadingManualCap(false)
    }
  }

  return (
    <React.Fragment>
      <Grid item xs={2}>
        <TextInput
          label="Retail Value"
          type="number"
          disabled={isLoadingManualCap}
          inputProps={{
            step: 0.01,
            min: 0,
          }}
          onKeyDown={blockInvalidCharFromNumberInput}
          source="leadContact.vehicle.vehicleSalvage.retailValue"
          onBlur={handleRetailChange}
        />
      </Grid>
      <Grid item xs={2}>
        <TextInput
          label="Manual Cap"
          type="number"
          className={
            record.leadContact.vehicle?.vehicleSalvage?.manualCap >
            (vehicleCap?.value ?? 0)
              ? 'highlight-red'
              : 'highlight-green'
          }
          disabled
          source="leadContact.vehicle.vehicleSalvage.manualCap"
        />
      </Grid>
    </React.Fragment>
  )
}

export default RetailAndManualInputs
